/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdFormProps, TdFormItemProps } from './type';

export const formDefaultProps: TdFormProps = {
  colon: false,
  contentAlign: 'left',
  disabled: undefined,
  id: undefined,
  labelAlign: 'right',
  labelWidth: '81px',
  preventSubmitDefault: true,
  readonly: undefined,
  requiredMark: undefined,
  resetType: 'empty',
  showErrorMessage: true,
  submitWithWarningMessage: false,
};

export const formItemDefaultProps: TdFormItemProps = {
  arrow: false,
  label: '',
  requiredMark: undefined,
  shouldUpdate: false,
  showErrorMessage: undefined,
};
